import { ActionType, } from 'typesafe-actions';

import * as actions from './actions';

export const FETCH_PRODUCTS_ATTRIBUTES_REQUEST = 'FETCH_PRODUCTS_ATTRIBUTES_REQUEST';
export const FETCH_PRODUCTS_ATTRIBUTES_SUCCEEDED = 'FETCH_PRODUCTS_ATTRIBUTES_SUCCEEDED';
export const FETCH_PRODUCTS_ATTRIBUTES_FAILED = 'FETCH_PRODUCTS_ATTRIBUTES_FAILED';
export type ProductsAttributesAction = ActionType<typeof actions>;

export type ProductsAttributesErrorType = {};
